import { CONSUMER_FE_URL, COSMOS_URL } from '../globals';

export const getOfferDashboardUrl = (addressToken?: string) => {
  if (addressToken) {
    return `${CONSUMER_FE_URL}/dashboard/sell/${addressToken}`;
  }

  return `${CONSUMER_FE_URL}/dashboard/sell`;
};

export const getSellerFlowUrl = (
  sellerInputUUID?: string,
  sellerFlowLastCompletedSlug?: string,
) => {
  if (!sellerInputUUID) {
    return COSMOS_URL;
  }

  if (sellerFlowLastCompletedSlug) {
    return `${CONSUMER_FE_URL}/seller-lead/${sellerInputUUID}/${sellerFlowLastCompletedSlug}`;
  }

  return `${CONSUMER_FE_URL}/seller-lead/${sellerInputUUID}`;
};
